
import {defineComponent} from 'vue';
import ScreenWrapper from "@/components/elements/ScreenWrapper.vue";
import {useState} from "@/hooks/state";
import {ScreenSliderPink} from "@/Screens.types";
import Slider from "@/components/elements/Slider.vue";

const state = useState();
export default defineComponent({
  components: {
    Slider,
    ScreenWrapper,
  },
  props: {
    msg: String,
    goTo: Function,
    config: Object as () => ScreenSliderPink,
  },

  setup() {
    return {
      state
    }
  },
  data() {
    return {
      screen: this.config.screenId,
    }
  },

  mounted() {
  },

  methods: {
    next() {
      this.goTo(this.config.screenNext)
    }, back() {
      this.goTo(-1)
    },
    answer(answer: string | number) {
      if (!answer) {
        // middle value
        if (this.config.answerOptions?.length > 0) {
          answer = this.config.answerOptions[Math.ceil(this.config.answerOptions.length / 2)].id;
        } else {
          // median step between min and max, with step
          answer = Math.ceil((this.config.answerMin + this.config.answerMax) / 2 / this.config.answerStep) * this.config.answerStep;
        }
      }

      const texts = {
        [this.config.answerKey]: this.$t(this.config.question),
      };

      if (this.config.answerOptions?.length > 0) {
        texts[answer] = this.$t(this.config.answerOptions.find(option => option.id === answer)?.name);
      }

      state.setAnswer(this.config.answerKey, answer, {
        ...texts
      });
      // this.next();
    }
  }
});
